import { t } from "i18next";

import { Box } from "@mui/material";

import {
  ctaButtonSx,
  ctaButtonWrapperSx
} from "@/src/pages/consumer/HomePage/components/HomePageHeader/homePageHeader.styles";
import { HomePageButton } from "@/src/pages/consumer/HomePage/HomePageContent";

import AB_TEST_IDS from "@/src/constants/abTestIds";

interface HeroCtaButtonProps {
  buttonText: string;
  onClick: () => void;
}

const HeroCtaButton = (props: HeroCtaButtonProps) => {
  const { buttonText, onClick } = props;

  return (
    <Box sx={ctaButtonWrapperSx}>
      <HomePageButton
        variant="contained"
        sx={ctaButtonSx}
        onClick={() => onClick()}
        buttonText={t(buttonText)}
        color="primary"
        textComponent="span"
        abTestId={AB_TEST_IDS.consumer.homepage.hero.primaryCta}
      />
    </Box>
  );
};

export default HeroCtaButton;
